<template>
<div class="product-modifier-component">
  <div class="form-group flex">
    <label class="custom-checkbox checkbox-sm py-1" :class="checkboxClasses">
      <span class="custom-checkbox-label text-sm opacity-80" :class="labelClasses">
        {{ modifierName }}
      </span>
      <input type="checkbox" v-model="checked" class="self-center" :disabled="shouldDisableSelf">
      <span class="checkbox self-center"></span>
    </label>
    <div v-if="shouldDisplayQuantityControls" class="w-1/4">
      <product-modifier-quantity-controls :min-quantity="productModifier.min_quantity"
                                          :max-quantity="productModifier.max_quantity"
                                          :limit-reached="limitReached"
                                          v-model="quantity"
      />
    </div>
  </div>
</div>
</template>

<script>
import ProductModifierQuantityControls from '@/components/products/partials/modifiers/ProductModifierQuantityControls'

export default {
  props: {
    value: {
      required: true,
    },

    productModifier: {
      required: true,
      type: Object,
    },

    nested: {
      required: false,
      type: Boolean,
      default: false,
    },

    limitReached: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  components: {
    ProductModifierQuantityControls,
  },

  computed: {
    modifier() {
      return this.productModifier.modifier
    },

    modifierName() {
      if (this.modifier.display_name) {
        return this.modifier.display_name
      }

      return this.modifier.name || ''
    },

    labelClasses() {
      return {
        'font-normal': !this.nested,
        'font-light': this.nested,
        'text-black': !this.shouldDisableSelf,
        'text-grey': this.shouldDisableSelf,
      }
    },

    checkboxClasses() {
      return {
        'w-3/4 pr-2': this.checked && this.productModifier.max_quantity > 1,
      }
    },

    shouldDisplayQuantityControls() {
      return this.checked && this.productModifier.max_quantity > 1
    },

    shouldDisableSelf() {
      return this.limitReached && this.quantity === 0
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value === undefined) {
          return this.$emit('input', {
            modifier_id: this.modifier.id,
            quantity: this.quantity,
          })
        }

        if (typeof this.value.quantity === 'number') {
          this.quantity = this.value.quantity
          this.checked = this.quantity > 0
        }
      },
    },

    checked: {
      immediate: true,
      handler() {
        if (this.checked) {
          this.quantity = 1
        } else {
          this.quantity = 0
        }

        this.$emit('input', {
          modifier_id: this.modifier.id,
          quantity: this.quantity,
        })
      },
    },

    quantity() {
      this.$emit('input', {
        modifier_id: this.modifier.id,
        quantity: this.quantity,
      })

      if (this.quantity === 0) {
        this.$nextTick(() => this.checked = false)
      } else if (!this.checked) {
        this.checked = true
      }
    },
  },

  data() {
    return {
      checked: false,
      quantity: 0,
    }
  }
}
</script>
